/** Texto de identificação de um laudo na tela: nunca imprime "null" nem "undefined". */
export const SEM_NUMERO = "Sem número";

/** Título = identificador TAG + sequência (laudoId); sem ele, "Sem número". */
export function tituloLaudo(laudo: { laudoId?: string | null }): string {
  return laudo.laudoId?.trim() || SEM_NUMERO;
}

/** Linha "Cartela: X" só quando existe cartela; senão null (a tela não mostra a linha). */
export function rotuloCartela(cartela?: string | null): string | null {
  const valor = cartela?.trim();
  return valor ? `Cartela: ${valor}` : null;
}
